import React, { useEffect, useState, useRef } from 'react';
import { Toast, Alert, Tab, Tabs, Col } from 'react-bootstrap';
import api from '../../seller-apis/api';
import {
  filterOrders
} from '../../seller-apis/apidataField';

import PaginationCom from '../common/Pagination';

import Popup from '../common/Popup';
import Myalert from '../common/Myalert';
import TrackOrderPopup from '../common/TrackOrder-Popup';

import '../order.css';
import OrderCardWeb from '../common/OrderCardWeb';
import { useAlert } from 'react-alert';
import { useOrderDateAlert, resetOrderDateFilter, resolveOrderDateRange } from './useOrderDateAlert';
import ProductSearch from '../common/ProductSearch';
import OrderSKUSearch from '../common/ProductSearch/OrderSKUSearch';
import moment from 'moment';
//SL-923
import { useSelector } from 'react-redux';
import MainLoader from '../common/Loader/PageLoader';

var dateFromWeb = moment().subtract(30, 'days').format('YYYY-MM-DD');
var dateToWeb = moment().format('YYYY-MM-DD');
var datesWeb;

var globalFilter = {
  "pageNo": 1,
  "statusFilter": ["DELIVERED"],
  "dates": {

  }
};
function DeliveredOrders(props) {
  const stateData = useSelector(state => state?.ActionReducer);//SL-923
  var outerdiv;
  var loaderDiv;
  const alert = useAlert()
  const showOrderDateAlert = useOrderDateAlert(alert)
  const [ennewloader, setennewloader] = useState("block");



  // Web states

  const [allOrders, setallOrders] = useState([]);
  const [allRecords, setallRecords] = useState(1);
  const [webFiltCurr, setwebFiltCurr] = useState();

  // Pagination related

  const [selectedPage, setSelectedPage] = useState(1);

  const [sortHistdatefrom, setHistsortdatefrom] = useState();
  const [sortHistdateto, setHistsortdateto] = useState();

  // Alert related states

  const [alertshow, setalertShow] = useState(false)
  const [alertMessage, setalertMessage] = useState();
  const [alertType, setalertType] = useState();


  // Toast

  const [showToast, setshowToast] = useState(false)

  const [compforPaginationweb, setcompforPaginationweb] = useState("allOrdersWeb");




  // Track order Popup

  const [selectedTrackwithin, setselectedTrackwithin] = useState(0)


  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [defUrl, setdefUrl] = useState();
  const [minValDate, setMinValDate] = useState("")

  // Web filter related states
  const [addressName, setAddressName] = useState("")
  const [orderId, setOrderId] = useState(undefined);
  const [orderName, setorderName] = useState();
  const [currInput, setcurrInput] = useState(["DELIVERED"]);
  const [isPopupTrackVisWeb, setisPopupTrackVisWeb] = useState("none");
  const [selectedtrackOrderWeb, setselectedtrackOrderWeb] = useState(0);
  const [detailPPrice, setdetailPPrice] = useState("");
  const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")
  const [searchType, setSearchType] = useState("Product Name");
  const [maxValDate, setMaxValDate] = useState("");
  //SL-675
  const [totalRcordId, setTotalReordId] = useState([]);
  //<Start-Here> Track button Issue | Ticket : SL-950
  const [selectedTransitDetail, setSelectedTransitDetail] = useState([]);
  const [selectedPopupId, setSelectedPopupId] = useState(null);
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
        isFirstRender.current = false; // skip first render
        return;
    }

    if(isPopupTrackVisWeb == "none") 
      setpopupVisibilitytrackWeb(true);
  }, [selectedTransitDetail]);
  //</End-Here> Track button Issue | Ticket : SL-950

  useEffect(() => {
    const { from, to } = resetOrderDateFilter();
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
    setMaxValDate(moment().format('YYYY-MM-DD'));
    setselectedTrackwithin(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(1)
    globalFilter = {
      "pageNo": 1,
      "statusFilter": ["DELIVERED"],
      "dates": {

      }
    };
    if (dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }
    if (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !=="") {
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if(daydiffer > 30){
          showOrderDateAlert("Date range cannot be more than 30 days.")
          return 0;
      }
      globalFilter.dates = {
        "from-updatedAt": dateFromWeb + 'T00:00:00',
        "to-updatedAt": dateToWeb + 'T23:59:59'
      }
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.productId.productName": orderName,
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.vendorDetails.addrName": addressName
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "orderId": orderId
    }
    applyLoader()
    if(orderId !== undefined || orderName !== undefined || addressName !== undefined || (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !==""))
    {
      setremoveFilterClass("invent_remove_filter_btn_active")
    }
    //SL-675
    globalFilter["productId"] = totalRcordId.length == 0 ? true : false;
    api.order.orders(filterOrders(globalFilter)).then((res) => {
      removeLoader()
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      if(totalRcordId.length == 0){//SL-675
        setTotalReordId(res?.productId);
        globalFilter["productId"] = false;
      }
    }).catch(err => {
      removeLoader()
      console.log(err)
    })
   
  }, [])


  useEffect(() => {
    if (addressName === "" || addressName === null) {
      setAddressName(undefined)
    }
  }, [addressName])


  useEffect(() => {
    if (orderId === "" || orderId === null) {
      setOrderId(undefined)
      if (globalFilter?.orderFilter?.orderId){
        delete globalFilter.orderFilter.orderId;
        globalFilter.pageNo = 1;
        setSelectedPage(1)
        getOrders()
      }
    }
  }, [orderId])


  useEffect(() => {
    if (orderName === "" || orderName === null) {
      setorderName(undefined)
    }
  }, [orderName])

  const getOrders = () => {
    try {
      applyLoader()
      api.order.orders(filterOrders(globalFilter)).then((res) => {
        removeLoader()
        setallOrders(res.data)
        setallRecords(res.totalRecords)
      }).catch(err => {
        throw new Error(err)
      })
    } catch (err) {
      removeLoader()
      console.log(err)
    }
  }


  // Popup for tracking
  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }


  function setpopupVisibilitytrackWeb(e) {
    if (e) {
      setisPopupTrackVisWeb("block")
    }
    else {
      setisPopupTrackVisWeb("none")
    }
  }




  function trackPopupWeb(e, trackNo, docketNo) {
    setselectedtrackOrderWeb(e)
    setselectedTrackwithin(trackNo)
  }




  function checkevent(e, name, selectedAddress = null) {//SL-923
    if (e.keyCode === 13) {
      if (name === "id" && orderId !== "") {
        applyLoader()
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "orderId": orderId
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order.orders(filterOrders(globalFilter)).then((res) => {
          console.log(res)
          setallOrders(res.data)
          setallRecords(res.data.length);
          removeLoader()
        }).catch(err => console.log(err));
      }
      else if (name === "name" && orderName !== "") {
        applyLoader()
        setSelectedPage(1)
        let ordersearchFilter=searchType!='sku'?{"products.productId._id": orderName}:{"products.productId._id": orderName};
        setcompforPaginationweb("webFilt")
        globalFilter.pageNo = 1
        globalFilter.orderFilter = {
          // ...globalFilter.orderFilter,
          ...ordersearchFilter
        }
        setremoveFilterClass("invent_remove_filter_btn_active")
        api.order.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          setwebFiltCurr("pName");
          removeLoader()
        }).catch(err => console.log(err));
      }
      else if (name === "address" /*&& addressName !== ""*/) {//SL-923
        setSelectedPage(1)
        setcompforPaginationweb("allOrdersWeb")
        applyLoader()
        setremoveFilterClass("invent_remove_filter_btn_active")
        globalFilter.pageNo = 1;
        globalFilter.orderFilter = {
          ...globalFilter.orderFilter,
          "products.vendorDetails.addrName": selectedAddress //addressName // SL-923
        }
        api.order.orders(filterOrders(globalFilter)).then((res) => {
          setallOrders(res.data)
          setallRecords(res.totalRecords)
          removeLoader()
        }).catch(err => console.log(err));
      }
    }
  }


  // Popup showing detail


  function detail(data, price) {
    setdetailPPrice(price)
    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }

  // Pagination

  function paginate(data) {
    applyLoader()
    setselectedTrackwithin(0)
    setselectedtrackOrderWeb(0)
    globalFilter.pageNo = data.number
    setSelectedPage(data.number)
    api.order.orders(filterOrders(globalFilter)).then((res) => {
      console.log(res.data)
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      removeLoader()
    }).catch(err => {
      console.log(err)
      removeLoader()
    })
  }


  function setdateweb(e, type) {
    const { from, to } = resolveOrderDateRange(type, e.target.value, dateFromWeb, dateToWeb);
    dateFromWeb = from;
    dateToWeb = to;
    setHistsortdatefrom(from);
    setHistsortdateto(to);
    datesWeb = {
      "from": dateFromWeb,
      "to": dateToWeb
    }
  }




  // Function to close all popups opened

  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key === "Esc" || evt.key === "Escape") {
      // setconfirmationState(false)
      setisPopupTrackVisWeb("none")
      setisDetailPopupVis("none")
    }
  };

  function applyLoader() {
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex")
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setennewloader("none")
  }


  function clearFilters() {
    applyLoader()
    setcompforPaginationweb("allOrdersWeb")
    globalFilter = {
      "pageNo": 1,
      "statusFilter": ["DELIVERED"],
      "dates": {

      }
    }
    setorderName("")
    setOrderId("")
    setAddressName("")
    setHistsortdatefrom("")
    setHistsortdateto("")
    dateFromWeb = ""
    dateToWeb = ""
    setSelectedPage(1)
    setselectedTrackwithin(0)
    setselectedtrackOrderWeb(0)
    api.order.orders(filterOrders(globalFilter)).then((res) => {
      console.log(res)
      removeLoader()
      setremoveFilterClass("invent_remove_filter_btn")
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
      setennewloader("none")
    }).catch(err => {
      setennewloader("none")
      console.log(err)
    })
  }

  function applyFilter() {
    setselectedTrackwithin(0)
    setselectedtrackOrderWeb(0)
    setSelectedPage(1)
    globalFilter.pageNo = 1;
    if (dateFromWeb === undefined || dateToWeb === undefined || dateFromWeb === "" || dateToWeb === "") {
      showOrderDateAlert("please select both date", "show");
      return false;
    }
    if (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !=="") {
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)
      if(daydiffer > 30){
          showOrderDateAlert("Date range cannot be more than 30 days.")
          return 0;
      }
      globalFilter.dates = {
        "from-updatedAt": dateFromWeb + 'T00:00:00',
        "to-updatedAt": dateToWeb + 'T23:59:59'
      }
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.productId.productName": orderName,
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "products.vendorDetails.addrName": addressName
    }
    globalFilter.orderFilter = {
      ...globalFilter.orderFilter,
      "orderId": orderId
    }
    applyLoader()
    if(orderId !== undefined || orderName !== undefined || addressName !== undefined || (dateFromWeb !== undefined && dateToWeb !== undefined && dateFromWeb !== "" && dateToWeb !==""))
    {
      setremoveFilterClass("invent_remove_filter_btn_active")
    }
    api.order.orders(filterOrders(globalFilter)).then((res) => {
      removeLoader()
      setdefUrl("manual-mandava-weeder")
      setallOrders(res.data)
      setallRecords(res.totalRecords)
    }).catch(err => {
      removeLoader()
      console.log(err)
    })
  }
  const filterSearch=(data)=>{
    //setorderName(data.data);
    //setSearchType(data.type)
    applyLoader();
    globalFilter['filters'] = { ...globalFilter.filters, "product-objectId": data.data }
    //Search Issue on Other than 1st Page SL-698 and SL-675
    if(globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = 1;
    setSelectedPage(1)
    api.order?.orders(filterOrders(globalFilter))
    .then((res) => {
      removeLoader()
      setallOrders(res.data)
      setallRecords(res.totalRecords)
    }).catch(err => {
      removeLoader()
      console.log(err)
    })
    if(globalFilter?.filters && globalFilter['filters']['product-objectId'])
      delete globalFilter['filters']['product-objectId'];
  }

  useEffect(()=>{
    if (orderName !== "" && orderName !== null && orderName !== undefined) {
      checkevent({ "keyCode": 13 }, "name");
    }
  },[orderName])

  //<Start-Here> Serach Ticket: SL-675
  /**
  * API Calling
  */
  const ApiCalling = (flag) => {
    applyLoader()
    if(globalFilter?.searchIds)
      delete globalFilter['searchIds'];
    globalFilter.pageNo = selectedPage;
    if (flag === "reset") {
      delete globalFilter?.filters?.["product-objectId"];
      globalFilter.pageNo = 1;
      setSelectedPage(1)
    }
    api.order?.orders(filterOrders(globalFilter))
    .then((res) => {
      removeLoader()
      setallOrders(res.data)
      setallRecords(res.totalRecords)
    }).catch(err => {
      removeLoader()
      console.log(err)
    })

   
}

/**
* Search By Keyword On Enter
*/
const searchByKeyword = (value, type, productIds) => {
  
  if(productIds.length > 0){
    applyLoader()
    if (type === "sku") {
      globalFilter['filters'] = { ...globalFilter.filters, "product-objectId": productIds?.[0] }
      if (globalFilter?.searchIds)
        delete globalFilter['searchIds'];
    }
    else {
      globalFilter['searchIds'] = productIds
    }
    //Search Issue on Other than 1st Page SL-698 and SL-675
    globalFilter.pageNo = 1;
    setSelectedPage(1);
    api.order?.orders(filterOrders(globalFilter))
    .then((res) => {
      removeLoader()
      setallOrders(res.data)
      setallRecords(res.totalRecords)
    }).catch(err => {
      removeLoader()
      console.log(err)
    })
    
   
  }
  else{
    setallOrders([]);
    setallRecords(0);
    
  }
}
//</End-Here> Serach Ticket: SL-675

  return (
    <>
      {alertshow === true ?
        <Alert variant="success" className="Myalert" style={{ "backgroundColor": alertType }} onClose={() => setalertShow(false)} dismissible>
          <Myalert
            message={alertMessage}
          />
        </Alert> : <></>
      }

      <div className="" id="orDeskContain">

        {/* New orders desktop */}
        <div class="tab">
        <div className='d-flex mb-3 justify-content-start'>
            {/* ******** */}
            <div className='theme-shed1 p-2'>
              <div className='m-auto mt-1'>
                <span className='payment_dates'>From: - <input type='date' min={minValDate} max={sortHistdateto || maxValDate || undefined} value={sortHistdatefrom} onChange={(e) => setdateweb(e, "from")}></input></span>
                <span className='mx-2 payment_dates'>To: - <input type='date' min={sortHistdatefrom || minValDate || undefined} value={sortHistdateto} onChange={(e) => setdateweb(e, "to")} max={maxValDate}></input></span>
                <span><button className='apply-btn px-3 py-1 ff_Pop fs-14' onClick={() => applyFilter()}>Apply</button></span>
                {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear</button></span> */}
              </div>
            </div>
            {/* ****** */}
          </div>
          <div className="table-responsive">
          <table className='ord_table new-table-design' style={{ "width": "100%" }}>
            <thead>
              <tr className='table_ord_title_row'>
                <th className='thead_title' style={{ "width": "10%" }}>Order ID
                  <br></br>
                  <input type="text" value={orderId} name="name" placeholder='Search' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e, "id")} />
                  <i class="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({"keyCode":13},"id")}></i>
                </th>

                <th className='thead_title pb-1' style={{ "width": "12%" }}>Date<br></br>
                </th>

                <th className='thead_title' style={{ "width": "10%" }}>Product image</th>

                <th className='thead_title' style={{ "width": "20%" }}>Product Name & SKU
                <br/>
                  <OrderSKUSearch 
                  filterSearch={filterSearch}
                  searchNewEnq={setorderName}
                  from={"orders"}
                  flag="Order" // set flag
                  apiCall={ApiCalling}
                  data="filedData"
                  totalRcordId={totalRcordId}
                  searchByKeyword={searchByKeyword}
                  apiurl="searchSellerOrdersFilter"
                  ordersSearchParam={filterOrders(globalFilter)}
                  />
                </th>

                <th className='thead_title' style={{ "width": "10%" }}>Transfer price</th>
                {stateData?.addresses?.data?.length > 0 && <th className='thead_title' style={{ "width": "10%" }}>Pickup Address
                  {/*<Start-Here> Pickup Address Dropdown | Ticket : SL-923 */}
                    <div className="dropdown-wrapper">
                        <select 
                          value={addressName}
                          onChange={(e)=>{
                            const value = e.target.value;
                            setAddressName(value);
                            //Immediately trigger search after selection
                            checkevent({ keyCode: 13 }, "address",value);
                          }}
                        >
                            <option value="">All</option>
                            {stateData?.addresses?.data.map((address) => (
                              <option key={address._id} value={address.firstName}>
                                {address.firstName}
                              </option>
                            ))}
                        </select>
                    </div>
                  {/*</End-Here> Pickup Address Dropdown | Ticket : SL-923 */}
                  {/*<input type="text" value={addressName} name="name" id="inputnameweb" placeholder='Search..' className='w-95 order_table_srch_input' onChange={(e) => setAddressName(e.target.value)} onKeyUp={(e) => checkevent(e, "address")} />
                  <i className="fa fa-search pointer search-space order_table_srch_input_icon" aria-hidden="true" onClick={() => checkevent({"keyCode":13},"address")}></i>*/}
                </th>}
                <th className='thead_title' style={{ "width": "5%" }}>Total package(s)</th>

                <th className='thead_title' style={{ "width": "20%" }}>Action required</th>
              </tr>

            </thead>
            <tbody>


              {allOrders.length > 0 ? allOrders.map((item, index) => {
                let baseImg;
                let date = new Date(item.createdAt);
                let d = date.toUTCString(item.createdAt);
                let newd = d.substr(4, 12)
                let delivDate = new Date(item.updatedAt)
                let delDate = delivDate.toUTCString(item.updatedAt)
                let newDelDate = delDate.substr(4, 12)
                let update = new Date(item.updatedAt);
                let upd = update.toUTCString(item.updatedAt);
                let upnewd = upd.substr(4, 12)
                console.log(item?.order?.orderPlaceDate)
                let orderPlaceDate = new Date(item?.order?.orderPlaceDate);
                let orderPlace = orderPlaceDate.toUTCString(item?.order?.orderPlaceDate);
                orderPlaceDate = orderPlace.substr(4, 12)
                if (item?.order?.products.length > 0) {
                  item?.order?.products?.[0]?.productId.images.map((item) => {

                    if (item.baseImage === true) {
                      if (item.image.startsWith("products")) {
                        baseImg = item.image;
                      }
                      else {
                        let img = item.image.substr("41")
                        baseImg = img;
                      }
                    }
                  })
                  if (item.order.products[0].selSubPrd && item.order.products[0].productId.combination) {
                    return (
                      <OrderCardWeb id={index}
                        taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                        type="New-Orders"
                        key={item._id}
                        nicknameAdd={item.order.products && item.order.products[0] && item.order.products[0].vendorDetails && item.order.products[0].vendorDetails.addrName ? item.order.products[0].vendorDetails.addrName : undefined}
                        updatedAt={upnewd}
                        orderPlaceDate={orderPlaceDate}
                        lead={item._id}
                        sku={item.order.products[0].productId.SKU}
                        date={newd}
                        orderId={item.order.orderId}
                        url={item.order.products[0].productId.urlKey}
                        productName={item.order.products[0].productId.productName}
                        price={item.order.products[0].purchase_price}
                        quantity={item.order.products[0].quantity}
                        orderMainId={item.order?._id}
                        status={item.status}
                        invoices={item.order.products[0].tracks}
                        image={baseImg}
                        deliveredOn={newDelDate}
                        popupdetailVis={setpopupVisibilityDetail}
                        popupVisibility={setpopupVisibilitytrackWeb}
                        selSubPrdVal={item.order.products[0].selSubPrd.value}
                        pdetail={detail}
                        vendor={item.vendor}
                        revokes={item.order.products[0].revokes}
                        combination={item.order.products[0].productId.combination[0].value}
                        revokeReason={item.revoke}
                        fun={trackPopupWeb}
                        orderStatus={item.order?.status}
                        //Platform Fee Ticket : SL-662
                        platformFee={item.order?.pfFees}
                        //SL-950
                        onTransitFetched={(_id,detail, orderId, trackNo) => {
                          setSelectedPopupId(_id);
                          setSelectedTransitDetail(detail);
                          setselectedtrackOrderWeb(orderId);
                          setselectedTrackwithin(trackNo);
                        }}
                        product={item.order?.products?.[0]?.productId}
                        order={item.order}
                      />
                    )
                  }
                  else {
                    return (
                      <OrderCardWeb id={index}
                        taxClass={item.order?.products?.[0]?.vendorDetails?.taxClass}
                        type="New-Orders"
                        nicknameAdd={item.order.products && item.order.products[0] && item.order.products[0].vendorDetails && item.order.products[0].vendorDetails.addrName ? item.order.products[0].vendorDetails.addrName : undefined}
                        updatedAt={upnewd}
                        key={item._id}
                        lead={item._id}
                        orderPlaceDate={orderPlaceDate}
                        date={newd}
                        pdetail={detail}
                        orderMainId={item.order?._id}
                        sku={item.order.products[0].productId.SKU}
                        url={item.order.products[0].productId.urlKey}
                        popupdetailVis={setpopupVisibilityDetail}
                        revokes={item.order.products[0].revokes}
                        orderId={item.order.orderId}
                        productName={item.order.products[0].productId.productName}
                        price={item.order.products[0].purchase_price}
                        quantity={item.order.products[0].quantity}
                        status={item.status}
                        deliveredOn={newDelDate}
                        invoices={item.order.products[0].tracks}
                        // isProductPickedFun={productPicked}
                        image={baseImg}
                        revokeReason={item.revoke}
                        vendor={item.vendor}
                        popupVisibility={setpopupVisibilitytrackWeb}
                        // isManifestDownloadedFun={isManifestDownloaded}
                        fun={trackPopupWeb}
                        orderStatus={item.order?.status}
                        //Platform Fee Ticket : SL-662
                        platformFee={item.order?.pfFees}
                        //SL-950
                        onTransitFetched={(_id,detail, orderId, trackNo) => {
                          setSelectedPopupId(_id);
                          setSelectedTransitDetail(detail);
                          setselectedtrackOrderWeb(orderId);
                          setselectedTrackwithin(trackNo);
                        }}
                        product={item.order?.products?.[0]?.productId}
                        order={item.order}
                      />
                    )
                  }

                }
                else {

                  return (
                    <OrderCardWeb id={index}
                      type="New-Orders"
                      lead={item._id}
                      key={item._id}
                      orderId={item?.order?.orderId}
                      status="noprodetail"
                    />
                  )
                }

              }) : ennewloader === "none" ? (
                <>
                  <tr className="order-no-results-row">
                    <td colSpan={8} className="order-no-results-cell">No Results Found</td>
                  </tr>
                </>
              ) : null}
              
            </tbody>
          </table>
          </div>
          {/* </Container> */}

          <div class="d-flex justify-content-center" id="enNewLoader" >
            <div style={{ "display": ennewloader }}>
              <MainLoader/>
            </div>
          </div>

          <PaginationCom
            number={allRecords}
            activ={selectedPage}
            paginate={paginate}
            comp={compforPaginationweb}
          />




        </div>



        {/* </div> */}

        {/* Toast */}
        <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
          <Toast.Header>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body>Download manifest to proceed with pickup.</Toast.Body>
        </Toast>






        {/* Track detail for web | Ticket : SL-950 */}
        {isPopupTrackVisWeb == 'block' && 
        <div id="popupTrackweb" className={`overlay ${isPopupTrackVisWeb == 'block' ? 'visible' : ''}`} style={{ "display": "block" }}>
            <TrackOrderPopup
              type="New-Orders"
              id={selectedPopupId}
              trackDetail={selectedTransitDetail}
              popupVisibility={setpopupVisibilitytrackWeb}
            /> 
        </div>}
        
        <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
          <Popup
            from="newOrder"
            description={productDetail[0].description}
            sdescription={productDetail[0].shortDescription}
            descriptionNew={productDetail[0].descriptionNew}
            specificationNew={productDetail[0].specificationNew}
            name={productDetail[0].productName}
            price={detailPPrice}
            SKU={productDetail[0].SKU}
            popupVisibility={setpopupVisibilityDetail}
            images={productDetail[0].images}
            videos={productDetail[0].videos}
            fixedImage={true}
          />
        </div>
      </div>
    </>
  )




}


export default DeliveredOrders;